import PerkPointDashboard from "./Dashboard";
import PortfolioDashboard from "./PortfolioDashboard";
import { usePerkPointScope } from "./programs/program-scope";

/** `/perkpoint`: all-program view for a Loyyal admin, program view otherwise. */
export default function PerkPointHome() {
  const { mode } = usePerkPointScope();
  return mode === "portfolio" ? <PortfolioDashboard /> : <PerkPointDashboard />;
}
